import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import BasicSelectField from '../fields/BasicSelectField';
import getLocaleMessages from '../../utils/localesMessages';

const { label, helperText } = getLocaleMessages('buttonsV3/currency');

const renderReceivableCurrency = (props) => {
  const options = [...props.receivableCurrency];
  return <BasicSelectField options={options} {...props} />;
};

function Currency({ receivableCurrency, handleAmountFormatChange }) {
  return (
    <Field
      id="receiverCurrency"
      name="receiverCurrency"
      component={renderReceivableCurrency}
      receivableCurrency={receivableCurrency}
      label={label}
      onChange={handleAmountFormatChange}
      helperText={helperText}
    />
  );
}

Currency.propTypes = {
  receivableCurrency: PropTypes.string,
  handleAmountFormatChange: PropTypes.func,
};

renderReceivableCurrency.propTypes = {
  receivableCurrency: PropTypes.string,
};

export default Currency;
